import { Component } from "@angular/core";
import { UntilDestroy } from "@ngneat/until-destroy";
import { Subscription, tap } from "rxjs";
import { LoanDashboardService } from "src/app/loan-layout/components/loan-dashboard/loan-dashboard.service";

@UntilDestroy({ arrayName: "subscriptions" })
@Component({
    selector: "web-alert-cards",
    templateUrl: "./alert-cards.component.html",
    styleUrls: ["./alert-cards.component.scss"],
})
export class AlertCardsComponent {
    subscriptions: Subscription[] = [];
    overDueEmiLabel = "";
    discount = 0;
    // A waiver means the customer has defaulted, so these promo/penalty alerts
    // are not applicable and must stay hidden.
    isWaiverApplied = false;

    constructor(public loanDashboardService: LoanDashboardService) {
        this.subscriptions.push(
            this.loanDashboardService.timeline$
                .pipe(
                    tap(async (res: any) => {
                        const loanDetails = res?.data;
                        this.isWaiverApplied = (loanDetails?.emis ?? []).some((emi: any) => emi?.isWaiverApplied);
                        if (loanDetails?.emis && loanDetails?.emis.length > 0) {
                            this.overDueEmiLabel = (loanDetails?.emis ?? [])
                                .filter((emi: any) => emi?.isOverDue)
                                .map((emi: any) => emi?.label)
                                .join(", ");
                        }

                        this.discount =
                            (loanDetails?.fullPayment?.interestDiscount?.discountTValue ?? 0) +
                            (loanDetails?.fullPayment?.foreCloseDiscount ?? 0);
                    })
                )
                .subscribe()
        );
    }
}
